import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { DynamicFormModule, PhoneFormControlModule, SelectFormControlModule, TextFormControlModule } from 'core/dynamic-form';
import { FixedScrollDirective, SharedComponentsModule } from 'core/shared-components';
import { DsgTranslatePipe } from '../../pipes/translate.pipe';
import { MobileToolbarContentDirective } from '../../root/sidenav/mobile-toolbar-content.directive';
import { ApplyClassOnChildDirective } from '../../shared-components/apply-class-on-child.directive';
import { DataGridModule } from '../../shared-components/data-grid/data-grid.module';
import { ScreenSizeClassesDirective } from '../../shared-components/screen-size-classes.directive';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UserSplugConfigComponent } from './user-detail/user-splug-config/user-splug-config.component';
import { UserSplugFormComponent } from './user-detail/user-splug-form/user-splug-form.component';
import { UserManagementComponent } from './user-management.component';
import { UserManagementService } from './user-management.service';
import { UserSetPasswordComponent } from './user-set-password/user-set-password.component';


@NgModule({
  declarations: [
    UserManagementComponent,
    UserDetailComponent,
    UserSplugConfigComponent,
    UserSplugFormComponent,
    UserSetPasswordComponent,
  ],
  providers: [
    UserManagementService
  ],
  imports: [
    CommonModule,
    DataGridModule,
    MatCardModule,
    TextFormControlModule,
    SelectFormControlModule,
    PhoneFormControlModule,
    DsgTranslatePipe,
    MatButtonModule,
    ReactiveFormsModule,
    DynamicFormModule,
    MatCheckboxModule,
    MatExpansionModule,
    SharedComponentsModule,
    MatIconModule,
    MatTabsModule,
    FixedScrollDirective,
    ApplyClassOnChildDirective,
    MobileToolbarContentDirective,
    ScreenSizeClassesDirective
  ]
})
export class UserManagementModule { }
